import { render, staticRenderFns } from "./Trivia18.vue?vue&type=template&id=00d312d7&scoped=true&"
import script from "./Trivia18.vue?vue&type=script&lang=js&"
export * from "./Trivia18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d312d7",
  null
  
)

export default component.exports